import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 5l6 0","key":"svg-0"}],["path",{"d":"M7 19l6 0","key":"svg-1"}],["path",{"d":"M14 5l-4 14","key":"svg-2"}]]

/**
 * IconItalic
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaXRhbGljIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMSA1bDYgMCIgLz4KICA8cGF0aCBkPSJNNyAxOWw2IDAiIC8+CiAgPHBhdGggZD0iTTE0IDVsLTQgMTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/italic
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconItalic = createReactComponent('outline', 'italic', 'Italic', __iconNode);

export default IconItalic;